import { ref } from "vue";

export const fullImageViewState = ref("")
